
































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { RouteRecord, Route } from 'vue-router'
import { Environment } from "@/environments/environment";
import { appConfig } from '@/config/appConfig';
import NavDataService from '@/api/service/app/navdata-service';
import {Subscription } from 'rxjs';

@Component({
})
export default class Breadcrumb extends Vue {

  /**
   * 面包屑列表
   *
   * @memberof Breadcrumb
   */
  private breadcrumbs: Array<any> = [];
  @Prop({default: []}) public menuItems!: any
  public finalMenuItems: any[] = []
  private baseMenu: any = [{
    id: 'x1',
    viewType: 'APPINDEX',
    label: 'CSS客户服务系统'
  }]
  /**
   * 面包屑分隔符
   *
   * @memberof Breadcrumb
   */
  private separator:string = appConfig.breadcrumbSeparator;

  /**
   * 导航服务
   *
   * @memberof Breadcrumb
   */
  private navDataService = NavDataService.getInstance();
  
  /**
   * 默认视图标识
   *
   * @memberof Breadcrumb
   */
  @Prop() public indexViewTag!: string;

  /**
   * 导航模式
   *
   * @memberof Breadcrumb
   */
  @Prop({default:'tab'}) public navModel?:string;

  /**
   * 监听路由
   *
   * @memberof Breadcrumb
   */
  @Watch('$route')
  private onRouteChange(route: Route) {
    this.getBreadcrumb()
  }


  /**
    * 导航服务事件
    *
    * @public
    * @type {(Subscription | undefined)}
    * @memberof Dev
    */
  public serviceStateEvent: Subscription | undefined;

  /**
   * vue  生命周期
   *
   * @memberof Breadcrumb
   */
  created() {
    this.getBreadcrumb();
    if(Object.is(this.navModel,"route")){
      this.serviceStateEvent = this.navDataService.serviceState.subscribe(({ action,name, data }:{ action:string,name:any,data:any }) => {
        if (Object.is(action, 'datarefresh')) {
            this.getBreadcrumb();
        }
      });
    }
  }

  /**
   * 获取面包屑数据
   * 
   * @memberof Breadcrumb
   */
  private getBreadcrumb() {
    if(Object.is(this.navModel,"route")){
      this.breadcrumbs = this.navDataService.getNavData();
      this.$forceUpdate();
    }else{
      let breadcrumbs: any = this.$route.matched.filter((item) => {
        return item.meta && item.meta.caption && item.name !== 'appindexview'
      }).map(item => {
        return {
          id: item.meta.caption,
          label: item.meta.caption
        }
      })
      this.$nextTick(() => {
        this.breadcrumbs = breadcrumbs.length > 0
          ? this.baseMenu.concat(breadcrumbs[breadcrumbs.length - 1])
          : [...this.baseMenu]
      })
    }
  }

  /**
   * 获取面包屑指定元素前一条数据
   * 
   * @memberof Breadcrumb
   */
  private getPreNavData(item:any){
    let preNavData:any = this.navDataService.getPreNavDataById(item.id);
    return preNavData.data;
  }

  /**
   * 判断是否为当前选中项
   * 
   * @memberof Breadcrumb
   */
  private isCurSelected(item:any,singleItem:any){
    return item.srfkey === singleItem.srfkey;
  }

/**
   * 跳转页面
   *
   * @returns
   * @memberof TabPageExp
   */
  public gotoPage(movedUrl?: any) {
    const removedUrlList: any = Array.isArray(movedUrl)
                                ? movedUrl
                                : movedUrl
                                  ? [movedUrl]
                                  : []
    const length = this.$store.state.historyPathList.length;
    if (length > 0) {
      const path = this.$store.state.historyPathList[length - 1];
      if (Object.is(path, this.$route.fullPath)) {
        return;
      }
      const index = this.$store.state.pageTagList.findIndex((page: any) =>
        Object.is(page.fullPath, path)
      );
      if (index >= 0) {
        const page = this.$store.state.pageTagList[index];
        this.$router.push({
          path: page.path,
          params: page.params,
          query: page.query
        });
        const emitParams: any = {
          pushTo: page.fullPath,
          removedUrlList: removedUrlList
        }
        this.$emit('pagePath', emitParams)
      }
    } else {
      let path: string | null = window.sessionStorage.getItem(
        Environment.AppName
      );
      if (path) {
        this.$router.push({ path: path });
        const emitParams: any = {
          pushTo: path,
          removedUrlList: removedUrlList
        }
        this.$emit('pagePath', emitParams)
      } else {
        this.$router.push("/");
        const emitParams: any = {
          pushTo: '/',
          removedUrlList: removedUrlList
        }
        this.$emit('pagePath', emitParams)
      }
    }
  }


  /**
   * 面包屑点击行为
   * 
   * @memberof Breadcrumb
   */
  private handleLink(item: any) {
      if(item && item.viewType && Object.is(item.viewType,"APPINDEX")){
        let path: string | null = window.sessionStorage.getItem(Environment.AppName);
        if (path) {
          const removedUrlList: any = this.$store.state.historyPathList
          this.$store.commit("removeAllPage");
          this.gotoPage(removedUrlList);
        } else {
          this.$router.push("/");
        }
      }else{
        this.$router.push(item).catch(err => {
          console.warn(err);
        });
      }
  }

  /**
   * 切换导航行为
   * 
   * @memberof Breadcrumb
   */
  private selectNavData($event:any,item:any){
    let preNavData:any = this.getPreNavData(item);
    let curSrfkey:any = $event;
    this.navDataService.serviceState.next({action:'viewrefresh',name:item.id, data:curSrfkey});
  }

    /**
     * 组件销毁
     *
     * @memberof Breadcrumb
     */
    public destroyed() {
        if (this.serviceStateEvent) {
            this.serviceStateEvent.unsubscribe();
        }
    }

    /**
     * 是否显示下拉列表
     *
     * @memberof Breadcrumb
     */
    public isShowSelected(item:any){
      return item.isselected && !this.$util.isEmpty(item.srfkey);
    }

}
